module.exports = __webpack_public_path__ + "a09ca60d56c9647c987e80e721adafc7.png";